 // Scripting to handle tabs interaction
 (function ($) {

   //Stop propagation on linked card anchor clicks
   $(document).on('click', '.card.linked-card a', function (e) {
     //$('.card.linked-card a, .card.no-excerpt a').click(function(e) {
     e.preventDefault();
   });

   //Capture card clicks outside of the anchors
   $(document).on('click', '.card.linked-card, .nav-button', function (e) {
     //$('.card.linked-card').click(function(e) {
     let $card = $(this).hasClass('card') ? $(this) : $(this).parents('.card');

     //  check for heading with popup link and add it to the anchor so the trigger will work without conflicts
     let $headingLink = $card.find('h1.open-popup-link, h2.open-popup-link, h3.open-popup-link, h4.open-popup-link, h5.open-popup-link');
      if($headingLink) {
        $headingLink.find('a').addClass('open-popup-link');
      }
     let $anchor = $card.find('a').first();

     if ($anchor.attr('href').length) {
       handleCardAnchorClick($anchor);
     }

   });

   //Stop propagation on linked related resource anchor clicks
   $(document).on('click', '.linked-cover a', function (e) {
     //$('.archive-item.related-resource a').click(function(e) {
     e.preventDefault();
   });

   //Capture card clicks outside of the anchors
   $(document).on('click', '.linked-cover', function (e) {
      //$('.archive-item.related-resource').click(function(e) {
      let $card = $(this).hasClass('linked-cover') ? $(this) : $(this).parents('.linked-cover');
      //  check for H4 heading with popup link and add it to the anchor so the trigger will work without conflicts
      let $headingLink = $card.find('h4.open-popup-link');
      if($headingLink) {
        $headingLink.find('a').addClass('open-popup-link');
      }
      let $anchor = $card.find('a');

      if ($anchor) {
        handleCardAnchorClick($anchor);
      }

   });


   //Centralized handling of the card clicks
   function handleCardAnchorClick($anchor) {
     
     //Modals have to trigger a special event to avoid recursive clicking
     if ($anchor.hasClass('open-popup-link')) {
       $anchor.trigger('click');
    //  } else if ($anchor.parent('h4.open-popup-link')){
    //    console.log('parent');
      //  $anchor.trigger('click');
     } else if ($anchor.attr('target') == '_blank') {
       window.open($anchor.attr('href'));
     } else {
       window.location = $anchor.attr('href');
     }
   }

 })(jQuery);
